<div [innerHtml]="htmlData | safe : 'html'"></div>
